import React from "react";
import styled from "styled-components";
import { transformDate } from "../utils/time";

const TournamentMaps = ({ maps }) => {
  return (
    <Maps>
      {maps
        ? maps.map((map) => {
            // Check if the map should be revealed based on revealDate
            const revealDate = new Date(map.revealDate);
            const currentDate = new Date();
            const shouldReveal = revealDate <= currentDate;

            return (
              <Map key={map.id}>
                <img
                  className="fade-slide-down-opacity-2"
                  src={
                    shouldReveal
                      ? map.mapImage
                      : "https://alexocampos.github.io/liga-espanhola-aoe2-static/maps/cm_generic.png"
                  }
                  alt={shouldReveal ? map.mapName : "Mapa oculto"}
                />
                <div>
                  {shouldReveal ? map.mapName : transformDate(map.revealDate)}
                </div>
              </Map>
            );
          })
        : ""}
    </Maps>
  );
};

const Maps = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
`;

const Map = styled.div`
  margin: 1rem;
  img {
    width: 16rem;
    max-height: 8rem;
  }
  div {
    transform: rotate(-28deg);
    width: 6rem;
    position: relative;
    top: -2rem;
    left: 11rem;
  }
`;

export default TournamentMaps;
